import { gql } from 'graphql-request';

export const COMPANY_NARRATIVE_FRAGMENT = gql`
  fragment CompanyFields on Narrative {
    company {
      id
      name
      tickerSymbol
      uniqueSymbol
      canonicalURL
      exchangeCountryISO
      info {
        url
      }
      secondaryIndustry {
        name
      }
      data {
        marketCap
        currencyInfo
      }
      score {
        value
        future
        past
        health
        dividend
        sentence
      }
      analysisDividend {
        dividendYield
      }
      analysisFuture {
        forwardPe1Y
        forwardPriceToSales1Y
        revenueGrowthAnnual
        netIncomeGrowthAnnual
      }
      analysisHealth {
        netIncome
      }
      analysisValue {
        pe
        pb
        priceToSales
        preferredRelativeMultiple
        lastSharePrice
        npvPerShare
        marketCapUSD
        intrinsicDiscount
        return7d
        return30d
        return90d
        return1yAbs
        priceTarget
        priceTargetAnalystCount
      }
      analysisMisc {
        analystCount
        sharesOutstandingSingleGrowth1Y
      }
      analysisPast {
        netIncome
        netIncomeMargin
        revenue
      }
    }
  }
`;
